export enum FontWeightAndStyleValueEnum {
  Bold = 'Bold',
  BoldItalic = 'BoldItalic',
  Normal = 'Normal',
  Italic = 'Italic',
}
